if(navigator.userAgent.match(/Trident\/7\./)) { // if IE
   document.body.addEventListener("wheel", function (event) {
        // remove default behavior
        event.preventDefault();
        //scroll without smoothing
        var wheelDelta = event.deltaY;
        var currentScrollPosition = window.pageYOffset;
        window.scrollTo(0, currentScrollPosition + wheelDelta);
    });
}


// WEBPACK FOOTER //
// ./assets/js/src/modules/ieparallaxbugfix.js